import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { Table } from "react-bootstrap";
import style from "./Notification.module.scss";
import { SortButton } from "../../components/utils/sortButton";
import Pagination from "../../components/paginationCopy/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteNotification,
  loadNotifications,
} from "../../redux/admin/actions/admin.actions";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import CreateNotification from "./CreateNotification";

const Notification = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [notificationId, setNotificationId] = useState("");

  const { notifications } = useSelector((state) => state.adminReducer);

  useLayoutEffect(() => {
    setLoading(true);
    dispatch(loadNotifications());
    setLoading(false);
  }, [dispatch]);
  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(notifications?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // sorting
  const [sortKey, setSortKey] = useState("name");
  const [sortOrder, setSortOrder] = useState("desc");

  function sortData({ tableData, sortKey, reverse }) {
    if (!sortKey) return tableData;

    const sortedData = notifications.sort((a, b) => {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    });

    if (reverse) {
      return sortedData.reverse();
    }

    return sortedData;
  }

  const sortedData = useCallback(
    () =>
      sortData({
        tableData: notifications,
        sortKey,
        reverse: sortOrder === "desc",
      }),
    [notifications, sortKey, sortOrder]
  );
  const headers = [
    { key: "index", label: "S/N" },
    { key: "title", label: "Title" },
    { key: "message", label: "Message" },
    { key: "unread", label: "Status" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };

  const handleRow = (data) => {
    setNotificationId(data.id);
    setConfirmModal(true);
  };
  return (
    <div>
      <div className={style.create} onClick={() => setCreateModal(true)}>
        Create <PlusOutlined />
      </div>
      <section style={{ maxWidth: "90%", margin: "auto" }}>
        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return (
                  <td key={row.key}>
                    {row.label}{" "}
                    <SortButton
                      columnKey={row.key}
                      onClick={() => changeSort(row.key)}
                      {...{ sortOrder, sortKey }}
                    />
                  </td>
                );
              })}
            </tr>
          </thead>
          {notifications?.length > 0 ? (
            <tbody>
              {sortedData()
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((not, index) => (
                  <tr
                    className={style.tableBodyRow}
                    key={index}
                    // onClick={() => handleRow(hosp)}
                  >
                    <td style={{ width: "7vw" }}>
                      {pageNumber * size + index + 1}
                    </td>
                    <td>{not?.title}</td>
                    <td>{not?.message}</td>
                    <td>{not?.unread === "0" ? "Read" : "Unread"}</td>

                    <td className="d-flex gap-3 justify-content-center align-items-center">
                      <DeleteFilled
                        className={style.action}
                        style={{ color: "#b70303", fontSize: "19px" }}
                        onClick={() => handleRow(not)}
                        // onClick={() => handleEdit(tick)}
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              No record found
            </div>
          )}
        </Table>
        {[]?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* create notification */}
      <ConfirmationModal
        open={createModal}
        handleClose={() => setCreateModal(false)}
        closemodal={() => setCreateModal(false)}
        bgcolor="white"
        width="30%"
        instruction={
          <>
            <CreateNotification
              onClickYes={() => {
                setCreateModal(false);
                dispatch(loadNotifications());
              }}
            />
          </>
        }
      />

      <ConfirmationModal
        open={confirmModal}
        handleClose={() => setConfirmModal(false)}
        closemodal={() => setConfirmModal(false)}
        bgcolor="white"
        width="20%"
        instruction={
          <>
            <p
              style={{
                textAlign: "center",
                margin: "1rem 0",
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              Are you sure?
            </p>
            <div className={style.confirmButtons}>
              <div
                className={style.cancel}
                onClick={() => setConfirmModal(false)}
              >
                Cancel
              </div>
              <div
                className={style.delete}
                onClick={() => {
                  dispatch(deleteNotification(notificationId));
                  setConfirmModal(false);
                }}
              >
                Delete
              </div>
            </div>
          </>
        }
      />
    </div>
  );
};

export default Notification;
